module.exports = __webpack_public_path__ + "static/media/Pin-Light-Moto.f7bfa1b8.svg";